// extracted by mini-css-extract-plugin
module.exports = {"content":"content-14uJp0dk","lunbo":"lunbo-1ZfQEV32","dotCurrent":"dotCurrent-2f7qs6OE","box":"box-2IkVzEr3","image":"image-tZCPqp0a","link":"link-CbQhDtKu"};